import { Banner } from '@procore/core-react'
import styled from 'styled-components'

export const StyledLoginBanner = styled(Banner)`
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  z-index: 1000;
  border-radius: 0;
  text-align: center;
`
